// extracted by mini-css-extract-plugin
export var acceptButton = "_14-6";
export var backdropBlur = "_14-0";
export var fullContent = "_14-5";
export var link = "_14-7";
export var linkIcon = "_14-8";
export var sideContent = "_14-4";
export var sideImage = "_14-3";
export var sideImageWrapper = "_14-2";
export var splitLayout = "_14-1";